<template>
    <BreadCrumb PageTitle="Liste des devoirs soumis" />
    <ViewDevoir/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ViewDevoir from "../../components/Devoir/ViewDevoir.vue";

    export default defineComponent({
      name: "ViewDevoirPage",
      components: {
        BreadCrumb,
        ViewDevoir,
      },
    });
  </script>